import React, { Component } from 'react';
import WatchlistCustomerSocialMediaComponent from './WatchlistCustomerSocialMediaComponent';
import { WatchlistCustomerDomains } from '../../../domain/watchlist/WatchlistCustomerDomains';
import WatchlistCustomerDataBreachesComponent from './WatchlistCustomerDataBreachesComponent';
import WatchlistCustomerDomainsComponent from './WatchlistCustomerDomainsComponent';

class WatchlistCustomerComponent extends Component<Props, State> {
  public state: State = new State();

  render() {
    const { customerResponse, customerLoading } = this.props;

    return (
      <div className='flex flex-col w-full gap-y-5'>
        <WatchlistCustomerSocialMediaComponent response={customerResponse} customerLoading={customerLoading} />
        <div className={'flex flex-col w-full md:flex-row  md:flex-wrap lg:flex-nowrap gap-4 rounded-[10px] justify-center'}>
          <WatchlistCustomerDataBreachesComponent response={customerResponse} customerLoading={customerLoading} />
          <WatchlistCustomerDomainsComponent response={customerResponse} customerLoading={customerLoading} />
        </div>
      </div>
    );
  }
}

interface Props {
  customerResponse: WatchlistCustomerDomains | undefined;
  customerLoading: boolean;
}

class State {}

export default WatchlistCustomerComponent;
